module.exports = __webpack_public_path__ + "static/food-basket-971e13dca495dfb30d6820c1149a3e11.svg";